import { Alert, AlertTitle, Box, CircularProgress, Typography, useTheme } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { motion } from "framer-motion"
import { useContext, useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Header from "./Header"
import Tabla from "./Tabla"

import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Tab from "@mui/material/Tab"
import moment from "moment/moment"
import { useLocation, useNavigate } from "react-router-dom"
import { pgdCicloFinalizado, pgdColaborador, pgdEquipoFetch, pgdEquipoFinalizadoFetch } from "../Redux/PGD"
import {
  COLUMNSMIPGDCOLABORADOR,
  COLUMNSMIPGDFINALIZADOS,
  COLUMNSPGDEQUIPO,
  COLUMNSPGDEQUIPOFINALIZADOS,
} from "../columnas/columnasPGD"
import { UserAuth } from "../context/AuthContext"
import TokenContext from "../context/TokenContext"
import TablaPGDEquipo from "./tablas/TablaPGDEquipo"
import { analytics } from '../Firebase'

const PGD = () => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const theme = useTheme()
  const navigate = useNavigate()
  const { empleado } = UserAuth()
  const location = useLocation();
  const [valuePrimerTab, setValuePrimerTab] = useState(location.state?.activeTab || "1") //value del tablist

  const getPgdColaboradorSelector = useSelector((store) => store.pgd.getPgdColaborador)
  const [getPgdColaborador, setGetPgdColaborador] = useState(false)
  const pgdColaboradorSelector = useSelector((store) => store.pgd.pgdColaborador)
  const [PGDColaborador, setPGDColaborador] = useState([])

  const getPgdCicloFinalizadoSelector = useSelector((store) => store.pgd.getPgdCicloFinalizado)
  const [getPgdCicloFinalizado, setGetPgdCicloFinalizado] = useState(false)
  const pgdCicloFinalizadoSelector = useSelector((store) => store.pgd.pgdCicloFinalizado)
  const [PGDCicloFinalizado, setPGDCicloFinalizado] = useState([])

  const getPgdEquipoSelector = useSelector((store) => store.pgd.getPgdEquipo)
  const [getPgdEquipo, setGetPgdEquipo] = useState(false)
  const pgdEquipoSelector = useSelector((store) => store.pgd.pgdEquipo)
  const [pgdEquipo, setpgdEquipo] = useState([])

  const getPgdEquipoFinalizadoSelector = useSelector((store) => store.pgd.getPgdEquipoFinalizado)
  const [getPgdEquipoFinalizado, setGetPgdEquipoFinalizado] = useState(false)
  const pgdEquipoFinalizadoSelector = useSelector((store) => store.pgd.pgdEquipoFinalizado)
  const [pgdEquipoFinalizado, setpgdEquipoFinalizado] = useState([])

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue)
  }

  const fechaHoy = new Date().toLocaleDateString()

  useEffect(() => {
    if (empleado && empleado.usuarioPortalRh) {
      // Extraer el nombre de usuario de la dirección de correo electrónico
      const userEmail = empleado.usuarioPortalRh;
      const userName = userEmail.split('@')[0];

      // Enviar el evento a Firebase Analytics con el nombre de usuario
      analytics.logEvent('screen_view', {
        screen_name: location.pathname,
        user_email: userName,
      });
    }
  }, [empleado, location]);

  useEffect(() => {
    if (token && Object.keys(empleado).length > 0) {
      dispatch(pgdColaborador(token, fechaHoy, empleado.usuarioPortalRh))
      dispatch(pgdCicloFinalizado(token, fechaHoy, empleado.usuarioPortalRh))
      dispatch(pgdEquipoFetch(token, moment(fechaHoy, "DD/MM/YY").format("YYYY-MM-DD"), empleado.usuarioPortalRh), empleado.usuarioPortalRh)
      dispatch(pgdEquipoFinalizadoFetch(token, moment(fechaHoy, "DD/MM/YY").format("YYYY-MM-DD"), empleado.usuarioPortalRh), empleado.usuarioPortalRh)
    }
  }, [token, empleado])

  useEffect(() => {
    if (pgdColaboradorSelector?.length > 0 && getPgdColaboradorSelector) {
      const array = []
      pgdColaboradorSelector.forEach((items) => {
        let statuscode = items["statuscode"];

        let fecha_inicio = (statuscode === 100000000 ) ? items["new_fechainicioautoevaluacion@OData.Community.Display.V1.FormattedValue"]
          : (statuscode === 100000001)? items["new_fechainicioevaluacindellider@OData.Community.Display.V1.FormattedValue"]
          : items["new_fechainiciofeedback@OData.Community.Display.V1.FormattedValue"];
        
        let fecha_finalizacion = (statuscode === 100000000 ) ? items["new_fechavencimientoautoevaluacin@OData.Community.Display.V1.FormattedValue"]
          : (statuscode === 100000001)? items["new_fechavencimientoevaluacindellider@OData.Community.Display.V1.FormattedValue"]
          : items["new_fechavencimientofeedback@OData.Community.Display.V1.FormattedValue"];
        
        let estadoEtapa = (statuscode === 100000000 ) ? items["new_estadodelaautoevaluacin@OData.Community.Display.V1.FormattedValue"]
          : (statuscode === 100000001)? items["new_estadodelaevaluacindellder@OData.Community.Display.V1.FormattedValue"]
          : items["new_estadodelencuentrodefeedback@OData.Community.Display.V1.FormattedValue"];

        let item = {
          id: items["new_evaluaciondepgdid"],
          periodo: items["_new_ciclo_value@OData.Community.Display.V1.FormattedValue"],
          inicio: fecha_inicio,
          finalizacion: fecha_finalizacion,
          definicionObjetivos: items["new_estadodelaautoevaluacin@OData.Community.Display.V1.FormattedValue"],
          instancia: items["statuscode@OData.Community.Display.V1.FormattedValue"],
          statuscode: items["statuscode"],
          estadoAutoevaluacion: items["new_estadodelaautoevaluacin@OData.Community.Display.V1.FormattedValue"],
          estadoEvaluacionLider: items["new_estadodelaevaluacindellder@OData.Community.Display.V1.FormattedValue"],
          estadoEtapa: estadoEtapa,
          scoreObjetivos: items["new_scoreglobaldeobjetivos@OData.Community.Display.V1.FormattedValue"],
          scoreCompetencias: items["new_scoreglobaldedompetencias@OData.Community.Display.V1.FormattedValue"],
        }
        array.push(item)
      })
      setPGDColaborador(array)
      setGetPgdColaborador(getPgdColaboradorSelector)
    } else if (pgdColaboradorSelector?.length === 0 && getPgdColaboradorSelector) {
      setGetPgdColaborador(getPgdColaboradorSelector)
    }
    if (pgdCicloFinalizadoSelector?.length > 0 && getPgdCicloFinalizadoSelector) {
      const consolidatedRecords = {};

      pgdCicloFinalizadoSelector.forEach(element => {
        const id = element.new_evaluaciondepgdid;


        if (!consolidatedRecords[id]) {
          consolidatedRecords[id] = {
            id,
            id: element["new_evaluaciondepgdid"],
            periodo: element["_new_ciclo_value@OData.Community.Display.V1.FormattedValue"],
            inicio: element["ab.new_fechadesde@OData.Community.Display.V1.FormattedValue"],
            finalizacion: element["ab.new_fechahasta@OData.Community.Display.V1.FormattedValue"],
            instancia: element["statuscode@OData.Community.Display.V1.FormattedValue"],
            statuscode: element["statuscode"],
            annotations: []
          };
        }
        consolidatedRecords[id].annotations.push({
          annotationid: element["ac.annotationid"],
          documentbody: element["ac.documentbody"],
          filename: element["ac.filename"],
          mimetype: element["ac.mimetype"]
        });
      });

      const consolidatedArray = Object.values(consolidatedRecords);
      setPGDCicloFinalizado(consolidatedArray)
      setGetPgdCicloFinalizado(getPgdCicloFinalizadoSelector)
    } else if (pgdCicloFinalizadoSelector?.length === 0 && getPgdCicloFinalizadoSelector) {
      setGetPgdCicloFinalizado(getPgdCicloFinalizadoSelector)
    }
    if (pgdEquipoSelector?.length > 0 && getPgdEquipoSelector) {
      const array = []
      pgdEquipoSelector.forEach((items) => {
        let statuscode = items["statuscode"];

        let fecha_inicio = (statuscode === 100000000 ) ? items["new_fechainicioautoevaluacion@OData.Community.Display.V1.FormattedValue"]
          : (statuscode === 100000001)? items["new_fechainicioevaluacindellider@OData.Community.Display.V1.FormattedValue"]
          : items["new_fechainiciofeedback@OData.Community.Display.V1.FormattedValue"];
        
        let fecha_finalizacion = (statuscode === 100000000 ) ? items["new_fechavencimientoautoevaluacin@OData.Community.Display.V1.FormattedValue"]
          : (statuscode === 100000001)? items["new_fechavencimientoevaluacindellider@OData.Community.Display.V1.FormattedValue"]
          : items["new_fechavencimientofeedback@OData.Community.Display.V1.FormattedValue"];
        
        let estadoEtapa = (statuscode === 100000000 ) ? items["new_estadodelaautoevaluacin@OData.Community.Display.V1.FormattedValue"]
          : (statuscode === 100000001)? items["new_estadodelaevaluacindellder@OData.Community.Display.V1.FormattedValue"]
          : items["new_estadodelencuentrodefeedback@OData.Community.Display.V1.FormattedValue"];

        let item = {
          id: items["new_evaluaciondepgdid"],
          periodo: items["_new_ciclo_value@OData.Community.Display.V1.FormattedValue"],
          evaluado: items["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
          inicio: fecha_inicio,
          finalizacion: fecha_finalizacion,
          definicionObjetivos: items["new_estadodelaautoevaluacin@OData.Community.Display.V1.FormattedValue"],
          instancia: items["statuscode@OData.Community.Display.V1.FormattedValue"],
          statuscode: items["statuscode"],
          estadoAutoevaluacion: items["new_estadodelaautoevaluacin@OData.Community.Display.V1.FormattedValue"],
          estadoEvaluacionLider: items["new_estadodelaevaluacindellder@OData.Community.Display.V1.FormattedValue"],
          estadoEtapa: estadoEtapa,
          scoreObjetivos: items["new_scoreglobaldeobjetivos@OData.Community.Display.V1.FormattedValue"],
          scoreCompetencias: items["new_scoreglobaldedompetencias@OData.Community.Display.V1.FormattedValue"],
        }
        array.push(item)
      })
      setpgdEquipo(array)
      setGetPgdEquipo(getPgdEquipoSelector)
    } else if (pgdEquipoSelector?.length === 0 && getPgdEquipoSelector) {
      setGetPgdEquipo(getPgdEquipoSelector)
    }
    if (pgdEquipoFinalizadoSelector?.length > 0 && getPgdEquipoFinalizadoSelector) {
      const consolidatedRecords = {};

      pgdEquipoFinalizadoSelector.forEach(element => {
        const id = element.new_evaluaciondepgdid;
        debugger;
        if (!consolidatedRecords[id]) {
          consolidatedRecords[id] = {
            id,
            id: element["new_evaluaciondepgdid"],
            periodo: element["_new_ciclo_value@OData.Community.Display.V1.FormattedValue"],
            evaluado: element["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
            inicio: element["ab.new_fechadesde@OData.Community.Display.V1.FormattedValue"],
            finalizacion: element["ab.new_fechahasta@OData.Community.Display.V1.FormattedValue"],
            instancia: element["statuscode@OData.Community.Display.V1.FormattedValue"],
            statuscode: element["statuscode"],
            annotations: []
          };
        }
        consolidatedRecords[id].annotations.push({
          annotationid: element["ae.annotationid"],
          documentbody: element["ae.documentbody"],
          filename: element["ae.filename"],
          mimetype: element["ae.mimetype"]
        });
      });

      const consolidatedArray = Object.values(consolidatedRecords);
      setpgdEquipoFinalizado(consolidatedArray)
      setGetPgdEquipoFinalizado(getPgdEquipoFinalizadoSelector)
    } else if (pgdEquipoFinalizadoSelector?.length === 0 && getPgdEquipoFinalizadoSelector) {
      setGetPgdEquipoFinalizado(getPgdEquipoFinalizadoSelector)
    }
  }, [pgdColaboradorSelector, pgdCicloFinalizadoSelector, pgdEquipoSelector, pgdEquipoFinalizadoSelector])

  const handleOpenPGDColaborador = (id) => {
    const status = PGDColaborador?.find((item) => item.id === id);

    if (status.statuscode !== 100000002) {
      navigate(`/programa-gestion-de-desempeno-autoevaluacion/${id}`, { state: { activeTab: valuePrimerTab, modal: "autoevaluacion" } })
    } else {
      navigate(`/evaluacion-feedback/${id}`, { state: { activeTab: valuePrimerTab, modal: "autoevaluacion" } })
    }
  }


  const columnsColaborador = useMemo(() => {
    const showScoreColumn = PGDColaborador.some(linea => linea.statuscode === 100000002 && linea.estadoEtapa == "Completa");
    debugger;
    if ( !showScoreColumn ) {
      return COLUMNSMIPGDCOLABORADOR.filter(column => column.accessorKey !== "scoreObjetivos" && column.accessorKey !== "scoreCompetencias" );
    }
    return COLUMNSMIPGDCOLABORADOR;
  }, [PGDColaborador]);

  const columnsEquipo = useMemo(() => {
    const showScoreColumn = pgdEquipo.some(linea => linea.statuscode === 100000002 && linea.estadoEtapa == "Completa");
    if ( !showScoreColumn ) {
      return COLUMNSPGDEQUIPO.filter(column => column.accessorKey !== "scoreObjetivos" && column.accessorKey !== "scoreCompetencias" );
    }
    return COLUMNSPGDEQUIPO;
  }, [pgdEquipo]);

  const handleOpenPGDFinalizado = (id) => {
    if (id) {
      navigate(`/evaluacion-feedback/${id}`)
    } else {
    }
  }

  const handleOpenPGDEquipoAutoEvaluacion = ( id, modal ) => {
    if (id && modal === "autoevaluacion") {
      navigate(`/programa-gestion-de-desempeno-autoevaluacion/${id}`, { state: { activeTab: valuePrimerTab, modal: "autoevaluacion" } })
    }
    if (id && modal === "encuentro feedback") {
      navigate(`/evaluacion-feedback/${id}`, { state: { activeTab: valuePrimerTab, modal: "autoevaluacion" } })
    }
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Header
          title={"Proceso Gestión del Desempeño"}
          subtitle={
            <>
              A través del PGD medimos nuestro aporte al logro de los objetivos organizacionales y de la Dirección a la que pertenecemos. Es un proceso anual que se compone de tres etapas: 1) Definición de Objetivos 2) Gestión y Seguimiento y 3) Conversación y balance de año.
              <br />
              <br />
              ¡Potenciando tu desarrollo, crecemos juntos!
            </>
          }

        />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <Box sx={{ p: 2 }}>
              <TabContext value={valuePrimerTab}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <TabList
                    aria-label="scrollable force tabs example"
                    onChange={handleChangePrimerTAB}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    textColor="secondary"
                    indicatorColor="secondary"
                  >
                    <Tab label="Mi PGD" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                    <Tab label="PGD Equipo" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                          Mi PGD como colaborador
                        </Typography>
                      </Box>
                      {!getPgdColaborador ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : PGDColaborador.length > 0 ? (
                        <Tabla
                          columnas={columnsColaborador}
                          lineas={PGDColaborador}
                          header={true}
                          acciones={true}
                          handleOpen={handleOpenPGDColaborador}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Mi PGD como colaborador</strong>.
                        </Alert>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                          Mis PGD ciclos finalizados
                        </Typography>
                      </Box>
                      {!getPgdCicloFinalizado ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : PGDCicloFinalizado.length > 0 ? (
                        <Tabla
                          columnas={COLUMNSMIPGDFINALIZADOS}
                          lineas={PGDCicloFinalizado}
                          header={true}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Mis PGD ciclos finalizados</strong>.
                        </Alert>
                      )}
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value="2">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                          PGD de mi equipo
                        </Typography>
                      </Box>
                      {!getPgdEquipo ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : pgdEquipo.length > 0 ? (
                        <TablaPGDEquipo
                          columnas={columnsEquipo}
                          lineas={pgdEquipo}
                          header={true}
                          handleOpen={handleOpenPGDEquipoAutoEvaluacion}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>PGD de mi equipo</strong>.
                        </Alert>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                          PGD de mi equipo finalizados
                        </Typography>
                      </Box>
                      {!getPgdEquipoFinalizado ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : pgdEquipoFinalizado.length > 0 ? (
                        <Tabla
                            columnas={COLUMNSPGDEQUIPOFINALIZADOS}
                            lineas={pgdEquipoFinalizado}
                            header={true}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>PGD de mi equipo finalizados</strong>.
                        </Alert>
                      )}
                    </Grid>
                  </Grid>
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </motion.div>
  )
}

export default PGD
